<template>
    <div id="transaction-information" class="tab-pane fade active show">
        <div class="row">
            <div class="col-12">
                <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div class="media">
                        <div class="wd-40 wd-md-50 ht-40 ht-md-50 tx-white mg-r-10 d-flex align-items-center justify-content-center rounded" :class="transactionType(transaction.type, false, true)" v-html="transactionType(transaction.type, true)"></div>
                        <div class="media-body">
                            <h5 class="mg-t-5 mg-b-0 tx-spacing--1" v-html="transactionType(transaction.type)"></h5>
                            <p class="tx-12 tx-medium tx-spacing-1 tx-color-03">{{ transaction.date|toDate('D MMM, YYYY [at] h:mm a') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h6 class="mg-b-20">Transaction Info</h6>
        <div class="row">
            <div class="col-12">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Transaction ID</label>
                <p class="mg-b-0">{{ transaction.uuid|placeholder }}</p>
            </div>
        </div>
        <div class="row">
            <div v-if="transaction.type !== 'Fees'" class="col-md-4 mg-t-20 mg-sm-t-30">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Units</label>
                <p class="mg-b-0">{{ transaction.units|toNumber('0,0.0000') }}</p>
            </div>
            <div class="col-md-4 mg-t-20 mg-sm-t-30">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10" v-html="(transaction.type === 'Fees') ? 'Amount':'Price'">Price</label>
                <p class="mg-b-0">{{ transaction.price|toCurrency(transaction.currency) }}</p>
            </div>
        </div>
        <h6 class="mg-t-40 mg-b-20">Security & Holding Details</h6>
        <div class="row">
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Security ISIN</label>
                <p class="mg-b-0">{{ transaction.asset.security_isin|placeholder }}</p>
            </div>
            <div class="col-md-4">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Security Name</label>
                <p class="mg-b-0">{{ (transaction.asset.name +' - '+transaction.asset.description)|placeholder }}</p>
            </div>
            <div v-if="hasRequest" class="col-12 mg-t-20 mg-sm-t-30">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Holding</label>
                <p class="mg-b-0">
                    <router-link class="text-small" :to="{ name: 'holdings.show', params: { id: transaction.request.id } }">Manage</router-link>
                </p>
            </div>
            <div class="col-12 mg-t-20 mg-sm-t-30">
                <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Portfolio</label>
                <p class="mg-b-0">
                    {{ transaction.external_portfolio_id|placeholder }}
                    <router-link class="ml-3 text-small" :to="{ name: 'portfolios.show', params: { portfolio: transaction.external_portfolio_id } }">Manage</router-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		mounted() {
			feather.replace();
		},
		computed: {
			hasRequest: function() {
				return this.transaction.request[0] !== null;
			}
		},
		props: ["transaction"]
	};
</script>